import { AditamentoDiferenca, AditamentoRevisionData } from './aditamentoRevisionModal';
import { DivergenciasData } from '../../requests/divergencias';

export const convertDivergenciasToAditamento = (
  divergenciasData: DivergenciasData
): AditamentoRevisionData => {
  const diferencas: AditamentoDiferenca[] = divergenciasData.divergencias.map(divergencia => ({
    tipoClasse: divergencia.tipoCampo,
    nomeCampo: divergencia.nomeCampo,
    oldField: divergencia.valorInstrumento,
    newField: divergencia.valorDesminutador,
    caminhoCompleto: `${divergencia.secao}.${divergencia.nomeCampo}`,
    enumValues: undefined
  }));

  const aditamentoData: AditamentoRevisionData = {
    aditamento: {
      id: parseInt(divergenciasData.validacao.id) || 0,
      instrumentoFinanceiroGuid: divergenciasData.validacao.id,
      statusAditamentoId: 1,
      tipoInstrumentoFinanceiro: divergenciasData.instrumentoTipo,
      usuarioId: 'sistema',
      dataDeCriacao: divergenciasData.dataValidacao,
      dataUltimaAlteracao: divergenciasData.dataValidacao,
      aditamentoCount: 0,
      aditamentoGuid: divergenciasData.validacao.id,
      new: '',
      old: ''
    },
    diferencas,
    instrumentoCodigo: divergenciasData.instrumentoCodigo
  };

  return aditamentoData;
};

export const isDivergenciasData = (data: any): data is DivergenciasData => {
  return data && 
         data.validacao && 
         data.divergencias && 
         Array.isArray(data.divergencias) &&
         data.instrumentoCodigo &&
         data.instrumentoTipo;
};
